import {faker}  from "@faker-js/faker";
import { getOrgApp } from "../helpers/get-orgApp";
import { regions } from "./regions";
import { getSelectedDepartmentFromAccount } from "../helpers/get-accounts";

const regionCodes = regions.map((reg) => reg.RegionCode);

export const allCfns = async (count, accountList, regionList) => {
  let cfns = [];
  let orgAppDetails = await getOrgApp();
  let selectedDepartments = [];
  if (accountList && accountList.length > 0) {
    selectedDepartments = getSelectedDepartmentFromAccount(
      orgAppDetails,
      accountList
    );
  }
  for (var i = 0; i < count; i++) {
    let selectedOrg = faker.helpers.arrayElement(orgAppDetails);
    let selectedDept = faker.helpers.arrayElement(
      selectedDepartments && selectedDepartments.length > 0
        ? selectedDepartments
        : selectedOrg.depts
    );
    let selectedDeptApp = faker.helpers.arrayElement(selectedDept.deptApps);
    let selectedDeptAccount = faker.helpers.arrayElement(
      selectedDept.deptAccounts
    );
    const cfnName =
      selectedDept.deptCode +
      "-" +
      selectedDeptApp.appEnv +
      "-Stack" +
      faker.helpers.arrayElement([1, 2]);
    cfns.push({
      Name: i === 0 ? "Elastic-Search-Blueprint" : cfnName,
      CreationTime: "2020-03-21 06:22:59",
      StackStatus: "CREATE_COMPLETE",
      UpdatedAt: null,
      AccountNumber: selectedDeptAccount.accountNumber,
      Description:
        "This template creates an IAM Role with AWS managed IAM Policies and customer managed policies attached to it. This role will be assumed by CloudFormation",
      Tags: [],
      LastUpdatedTime: null,
      CreatedAt: null,
      ResourceId:
        "arn:aws:cloudformation:ap-southeast-2:9876543210:stack_MontyCloud-Role-Permissions-EC2-Windows-Instance_6827a5a0-6b3c-11ea-907c-0a977ce3ec84",
      RegionCode:
        regionList && regionList.length
          ? faker.helpers.arrayElement(regionList)
          : faker.helpers.arrayElement(regionCodes),
      OrganizationId: selectedOrg.orgId,
      DepartmentId: "98ea91b7-551f-4d35-a113-b37fcd840a71",
      ApplicationId: selectedDeptApp && selectedDeptApp.appId,
      EnvironmentId: selectedDeptApp && selectedDeptApp.appEnvId,
      ResourceName: i === 0 ? "Elastic-Search-Blueprint" : cfnName,
      ResourceCount: i === 0 ? 16 : faker.number.int({ min: 0, max: 100 }),
    });
  }
  return cfns;
};

const resourceTypes = [
  {
    ResourceType: "Instance",
    Count: 3,
  },
  {
    ResourceType: "SecurityGroup",
    Count: 3,
  },
  {
    ResourceType: "LoadBalancer",
    Count: 2,
  },
  {
    ResourceType: "IAMRole",
    Count: 1,
  },
  {
    ResourceType: "Volume",
    Count: 6,
  },
  {
    ResourceType: "S3",
    Count: 1,
  },
];

export const cfnResources = (selectedCfn, resources) => {
  let vpcResources = [];
  resourceTypes.forEach((resourceType) => {
    let filteredResources = [];
    filteredResources = resources.filter(
      (el) =>
        el.ResourceType === resourceType.ResourceType &&
        el.AccountNumber === selectedCfn.AccountNumber
    );
    const selected = filteredResources.slice(0, resourceType.Count);
    selected.forEach((res, index) => {
      let resource = { ...res };
      resource.Region = selectedCfn.RegionCode;
      resource.ApplicationId = "default";
      resource.EnvironmentId = "default";
      if (res.ResourceType === "Instance") {
        if (index === 0) {
          resource.ResourceName = "master-node-1";
        }
        if (index === 1) {
          resource.ResourceName = "data-node-1";
        }
        if (index === 2) {
          resource.ResourceName = "data-node-2";
        }
      }
      vpcResources.push(resource);
    });
  });

  return vpcResources;
};
